import { useOutletContext } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { StatusPill } from "../../components/StatusPill";
import { Plus, Clock3 } from "lucide-react";

export default function PortalRequests() {
  const { requests, openRequestDialog } = useOutletContext();

  return (
    <div className="p-6 md:p-8 space-y-6 max-w-[1300px]">
      <div className="flex items-end justify-between flex-wrap gap-4">
        <div>
          <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-orange-400">Ask Your Team</div>
          <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight mt-1">Creative Requests</h1>
          <p className="text-neutral-600 text-sm mt-1">{requests.length} {requests.length===1?"request":"requests"} on record</p>
        </div>
        <Button onClick={openRequestDialog} data-testid="new-request-btn" className="bg-orange-500 hover:bg-orange-600 text-white">
          <Plus className="w-4 h-4 mr-1"/> New Request
        </Button>
      </div>

      <div className="space-y-3">
        {requests.length === 0 && (
          <div className="panel p-10 text-center">
            <div className="text-lg font-bold">No requests yet</div>
            <div className="text-sm text-neutral-500 mt-1">Need a new creative? Raise a request and your team gets notified instantly.</div>
            <Button onClick={openRequestDialog} className="mt-4 bg-orange-500 hover:bg-orange-600 text-white">
              <Plus className="w-4 h-4 mr-1"/> Raise your first request
            </Button>
          </div>
        )}
        {requests.map(r => (
          <div key={r.id} className="panel p-5" data-testid={`request-${r.id}`}>
            <div className="flex items-start justify-between gap-4 flex-wrap">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <div className="text-base font-semibold">{r.title}</div>
                  <span className={`pill ${r.priority==="High"?"pill-revision":r.priority==="Low"?"pill-draft":"pill-pending"}`}>{r.priority} priority</span>
                  <span className={`pill ${r.status==="Open"?"pill-pending":r.status==="Delivered"?"pill-published":"pill-scheduled"}`}>{r.status}</span>
                </div>
                {r.description && <div className="text-sm text-neutral-700 mt-2 whitespace-pre-wrap">{r.description}</div>}
              </div>
              <div className="text-right text-[11px] font-mono text-neutral-500">
                {r.deadline && <div className="flex items-center gap-1 justify-end"><Clock3 className="w-3 h-3"/>{r.deadline}</div>}
                <div>Raised {(r.created_at||"").slice(0,10)}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
